import "./login.css";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import planeImg from "../../../assets/imgs/login/login-bg-img.png";
import logoAmc from "../../../assets/imgs/login/logo-amc.png";
import pinkLines from "../../../assets/imgs/login/pink-lines.svg";
import logoHorus from "../../../assets/imgs/login/horus-logo.svg";

function Login() {
  const { loginWithRedirect, isLoading, isAuthenticated } = useAuth0();
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      await loginWithRedirect();
    } catch (error) {
      console.error("Error logging in:", error);
      alert("Error al iniciar sesión. Verifica la configuración de Auth0.");
    }
  };

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("tokenExpire");
      localStorage.removeItem("user");
    } else if (isAuthenticated) {
      navigate("/dashboard/admin");
    }
  }, [isLoading, isAuthenticated]);

  return (
    <div className="login-container container-fluid gx-0">
      <div className="row vh-100 g-0">
        <div className="col-12 col-lg-7 left-column">
          <div className="image-wrapper">
            <img
              src={planeImg}
              alt="Avión de Aeromexico sobre las nubes"
              className="plane-image"
            />
          </div>
          <div className="logo-wrapper text-center">
            <img
              src={logoAmc}
              alt="Logo de Aeromexico Cargo"
              className="logo-amc"
            />
            <img src={pinkLines} className="pink-lines" alt="Pink lines" />
          </div>
        </div>

        <div className="col-12 col-lg-5 d-flex justify-content-center align-items-center position-relative">
          <div className="login-form-container">
            <img src={logoHorus} className="logo-horus" alt="Horus logo" />
            <div className="form-container">
              <button onClick={handleLogin} className="login-button">
                Iniciar sesión
              </button>
            </div>
          </div>
          <div className="copyright-text">
            <p>
              ©Copyright {new Date().getFullYear()} | Derechos Reservados,
              Aeroméxico Cargo.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
